import { CurrencyType } from "../../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.ExternalApi.ViewModels.Suite.CurrencyType */
export { CurrencyType };
import { PropertyGroupType } from "../../../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.ExternalApi.ViewModels.Suite.PropertyGroupType */
export { PropertyGroupType };
/** CoStar.Api.ExternalApi.ViewModels.Suite.PropertyGroupSubtype */
export var PropertyGroupSubtype;
(function (PropertyGroupSubtype) {
    PropertyGroupSubtype[PropertyGroupSubtype["None"] = 0] = "None";
    PropertyGroupSubtype[PropertyGroupSubtype["AirportRetail"] = 1] = "AirportRetail";
    PropertyGroupSubtype[PropertyGroupSubtype["CommunityCenter"] = 2] = "CommunityCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["LifestyleCenter"] = 3] = "LifestyleCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["NeighborhoodCenter"] = 4] = "NeighborhoodCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["OutletCenter"] = 5] = "OutletCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["PowerCenter"] = 6] = "PowerCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["RegionalMall"] = 7] = "RegionalMall";
    PropertyGroupSubtype[PropertyGroupSubtype["ThemeFestivalCenter"] = 8] = "ThemeFestivalCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["StripCenter"] = 9] = "StripCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["SuperRegionalMall"] = 10] = "SuperRegionalMall";
    PropertyGroupSubtype[PropertyGroupSubtype["RegionalPrime"] = 11] = "RegionalPrime";
    PropertyGroupSubtype[PropertyGroupSubtype["MajorUrbanCentre"] = 12] = "MajorUrbanCentre";
    PropertyGroupSubtype[PropertyGroupSubtype["UrbanCentre"] = 13] = "UrbanCentre";
    PropertyGroupSubtype[PropertyGroupSubtype["District"] = 14] = "District";
    PropertyGroupSubtype[PropertyGroupSubtype["SolusUnit"] = 15] = "SolusUnit";
    PropertyGroupSubtype[PropertyGroupSubtype["ShoppingPark"] = 16] = "ShoppingPark";
    PropertyGroupSubtype[PropertyGroupSubtype["RetailPark"] = 17] = "RetailPark";
    PropertyGroupSubtype[PropertyGroupSubtype["LeisurePark"] = 18] = "LeisurePark";
    PropertyGroupSubtype[PropertyGroupSubtype["OfficePark"] = 19] = "OfficePark";
    PropertyGroupSubtype[PropertyGroupSubtype["IndustrialPark"] = 20] = "IndustrialPark";
})(PropertyGroupSubtype || (PropertyGroupSubtype = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.PropertySubtype */
export var PropertySubtype;
(function (PropertySubtype) {
    PropertySubtype[PropertySubtype["None"] = 0] = "None";
    PropertySubtype[PropertySubtype["FlexLightManufacturing"] = 1] = "FlexLightManufacturing";
    PropertySubtype[PropertySubtype["FlexResearchAndDevelopment"] = 2] = "FlexResearchAndDevelopment";
    PropertySubtype[PropertySubtype["FlexShowroom"] = 3] = "FlexShowroom";
    PropertySubtype[PropertySubtype["GeneralRetailAutoDealership"] = 4] = "GeneralRetailAutoDealership";
    PropertySubtype[PropertySubtype["GeneralRetailAutoRepair"] = 5] = "GeneralRetailAutoRepair";
    PropertySubtype[PropertySubtype["GeneralRetailBank"] = 6] = "GeneralRetailBank";
    PropertySubtype[PropertySubtype["GeneralRetailBar"] = 7] = "GeneralRetailBar";
    PropertySubtype[PropertySubtype["SpecialtyCarwash"] = 8] = "SpecialtyCarwash";
    PropertySubtype[PropertySubtype["GeneralRetailConvenienceStore"] = 9] = "GeneralRetailConvenienceStore";
    PropertySubtype[PropertySubtype["GeneralRetailDaycareCenter"] = 10] = "GeneralRetailDaycareCenter";
    PropertySubtype[PropertySubtype["GeneralRetailDrugstore"] = 11] = "GeneralRetailDrugstore";
    PropertySubtype[PropertySubtype["GeneralRetailFastFood"] = 12] = "GeneralRetailFastFood";
    PropertySubtype[PropertySubtype["GeneralRetailFuneralHome"] = 13] = "GeneralRetailFuneralHome";
    PropertySubtype[PropertySubtype["GeneralRetailFreestanding"] = 14] = "GeneralRetailFreestanding";
    PropertySubtype[PropertySubtype["GeneralRetailGardenCenter"] = 15] = "GeneralRetailGardenCenter";
    PropertySubtype[PropertySubtype["SpecialtyParkingGarage"] = 16] = "SpecialtyParkingGarage";
    PropertySubtype[PropertySubtype["SpecialtyParkingLot"] = 17] = "SpecialtyParkingLot";
    PropertySubtype[PropertySubtype["GeneralRetailRestaurant"] = 18] = "GeneralRetailRestaurant";
    PropertySubtype[PropertySubtype["GeneralRetailServiceStation"] = 19] = "GeneralRetailServiceStation";
    PropertySubtype[PropertySubtype["GeneralRetailStorefront"] = 20] = "GeneralRetailStorefront";
    PropertySubtype[PropertySubtype["GeneralRetailStorefrontRetailOffice"] = 21] = "GeneralRetailStorefrontRetailOffice";
    PropertySubtype[PropertySubtype["GeneralRetailStorefrontRetailResidential"] = 22] = "GeneralRetailStorefrontRetailResidential";
    PropertySubtype[PropertySubtype["GeneralRetailSupermarket"] = 23] = "GeneralRetailSupermarket";
    PropertySubtype[PropertySubtype["GeneralRetailTruckStop"] = 24] = "GeneralRetailTruckStop";
    PropertySubtype[PropertySubtype["GeneralRetailVeterinarianKennel"] = 25] = "GeneralRetailVeterinarianKennel";
    PropertySubtype[PropertySubtype["HealthcareAssistedLiving"] = 26] = "HealthcareAssistedLiving";
    PropertySubtype[PropertySubtype["HealthcareCongregateSeniorHousing"] = 27] = "HealthcareCongregateSeniorHousing";
    PropertySubtype[PropertySubtype["HealthcareContinuingCareRetirementCommunity"] = 28] = "HealthcareContinuingCareRetirementCommunity";
    PropertySubtype[PropertySubtype["HealthcareHospital"] = 29] = "HealthcareHospital";
    PropertySubtype[PropertySubtype["HealthcareRehabilitationCenter"] = 30] = "HealthcareRehabilitationCenter";
    PropertySubtype[PropertySubtype["HealthcareSkilledNursingFacility"] = 31] = "HealthcareSkilledNursingFacility";
    PropertySubtype[PropertySubtype["HospitalityHotel"] = 32] = "HospitalityHotel";
    PropertySubtype[PropertySubtype["HospitalityHotelCasino"] = 33] = "HospitalityHotelCasino";
    PropertySubtype[PropertySubtype["HospitalityMotel"] = 34] = "HospitalityMotel";
    PropertySubtype[PropertySubtype["SpecialtyAirport"] = 35] = "SpecialtyAirport";
    PropertySubtype[PropertySubtype["SpecialtyAirplaneHangar"] = 36] = "SpecialtyAirplaneHangar";
    PropertySubtype[PropertySubtype["SpecialtyAutoSalvageFacility"] = 37] = "SpecialtyAutoSalvageFacility";
    PropertySubtype[PropertySubtype["SpecialtyCementGravelPlant"] = 38] = "SpecialtyCementGravelPlant";
    PropertySubtype[PropertySubtype["SpecialtyChemicalOilRefinery"] = 39] = "SpecialtyChemicalOilRefinery";
    PropertySubtype[PropertySubtype["IndustrialTelecomHotelDataHosting"] = 40] = "IndustrialTelecomHotelDataHosting";
    PropertySubtype[PropertySubtype["IndustrialDistribution"] = 41] = "IndustrialDistribution";
    PropertySubtype[PropertySubtype["IndustrialFoodProcessing"] = 42] = "IndustrialFoodProcessing";
    PropertySubtype[PropertySubtype["SpecialtyLandfill"] = 43] = "SpecialtyLandfill";
    PropertySubtype[PropertySubtype["IndustrialManufacturing"] = 44] = "IndustrialManufacturing";
    PropertySubtype[PropertySubtype["SpecialtyRailroadYard"] = 45] = "SpecialtyRailroadYard";
    PropertySubtype[PropertySubtype["IndustrialRefrigerationColdStorage"] = 46] = "IndustrialRefrigerationColdStorage";
    PropertySubtype[PropertySubtype["SpecialtySelfStorage"] = 47] = "SpecialtySelfStorage";
    PropertySubtype[PropertySubtype["SpecialtyShipyard"] = 48] = "SpecialtyShipyard";
    PropertySubtype[PropertySubtype["IndustrialShowroom"] = 49] = "IndustrialShowroom";
    PropertySubtype[PropertySubtype["IndustrialTruckTerminal"] = 50] = "IndustrialTruckTerminal";
    PropertySubtype[PropertySubtype["SpecialtyUtilitySubstation"] = 51] = "SpecialtyUtilitySubstation";
    PropertySubtype[PropertySubtype["IndustrialWarehouse"] = 52] = "IndustrialWarehouse";
    PropertySubtype[PropertySubtype["SpecialtyWaterTreatmentFacility"] = 53] = "SpecialtyWaterTreatmentFacility";
    PropertySubtype[PropertySubtype["MixedUse"] = 57] = "MixedUse";
    PropertySubtype[PropertySubtype["MultifamilyApartments"] = 58] = "MultifamilyApartments";
    PropertySubtype[PropertySubtype["MultifamilyManufacturedHousingMobileHomePark"] = 62] = "MultifamilyManufacturedHousingMobileHomePark";
    PropertySubtype[PropertySubtype["OfficeLoftCreativeSpace"] = 63] = "OfficeLoftCreativeSpace";
    PropertySubtype[PropertySubtype["OfficeMedical"] = 64] = "OfficeMedical";
    PropertySubtype[PropertySubtype["SpecialtyCemeteryMausoleum"] = 72] = "SpecialtyCemeteryMausoleum";
    PropertySubtype[PropertySubtype["SpecialtyCorrectionalFacility"] = 73] = "SpecialtyCorrectionalFacility";
    PropertySubtype[PropertySubtype["SpecialtyLodgeMeetingHall"] = 74] = "SpecialtyLodgeMeetingHall";
    PropertySubtype[PropertySubtype["SpecialtyMarina"] = 75] = "SpecialtyMarina";
    PropertySubtype[PropertySubtype["SpecialtyMovieRadioTVStudio"] = 76] = "SpecialtyMovieRadioTVStudio";
    PropertySubtype[PropertySubtype["SpecialtyPoliceFireStation"] = 77] = "SpecialtyPoliceFireStation";
    PropertySubtype[PropertySubtype["SpecialtyPostOffice"] = 78] = "SpecialtyPostOffice";
    PropertySubtype[PropertySubtype["SpecialtyPublicLibrary"] = 79] = "SpecialtyPublicLibrary";
    PropertySubtype[PropertySubtype["SpecialtyRadioTVTransmissionFacilities"] = 80] = "SpecialtyRadioTVTransmissionFacilities";
    PropertySubtype[PropertySubtype["SpecialtyReligiousFacility"] = 81] = "SpecialtyReligiousFacility";
    PropertySubtype[PropertySubtype["SpecialtySchools"] = 82] = "SpecialtySchools";
    PropertySubtype[PropertySubtype["SpecialtyTrailerCamperPark"] = 83] = "SpecialtyTrailerCamperPark";
    PropertySubtype[PropertySubtype["SpecialtyWineryVineyard"] = 84] = "SpecialtyWineryVineyard";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentAmusementPark"] = 85] = "SportsAndEntertainmentAmusementPark";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentBaseballField"] = 86] = "SportsAndEntertainmentBaseballField";
    PropertySubtype[PropertySubtype["GeneralRetailBowlingAlley"] = 87] = "GeneralRetailBowlingAlley";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentCasino"] = 88] = "SportsAndEntertainmentCasino";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentGolfCourseDrivingRange"] = 89] = "SportsAndEntertainmentGolfCourseDrivingRange";
    PropertySubtype[PropertySubtype["GeneralRetailHealthClub"] = 90] = "GeneralRetailHealthClub";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentHorseStables"] = 91] = "SportsAndEntertainmentHorseStables";
    PropertySubtype[PropertySubtype["GeneralRetailMovieTheatre"] = 92] = "GeneralRetailMovieTheatre";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentRacetrack"] = 93] = "SportsAndEntertainmentRacetrack";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentSkatingRink"] = 94] = "SportsAndEntertainmentSkatingRink";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentSwimmingPool"] = 95] = "SportsAndEntertainmentSwimmingPool";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentTheaterConcertHall"] = 96] = "SportsAndEntertainmentTheaterConcertHall";
    PropertySubtype[PropertySubtype["IndustrialService"] = 97] = "IndustrialService";
    PropertySubtype[PropertySubtype["OfficeTelecomHotelDataHosting"] = 98] = "OfficeTelecomHotelDataHosting";
    PropertySubtype[PropertySubtype["FlexTelecomHotelDataHosting"] = 99] = "FlexTelecomHotelDataHosting";
    PropertySubtype[PropertySubtype["FlexLightDistribution"] = 104] = "FlexLightDistribution";
    PropertySubtype[PropertySubtype["SpecialtyWaterRetentionFacility"] = 105] = "SpecialtyWaterRetentionFacility";
    PropertySubtype[PropertySubtype["SpecialtySororityFraternityHouse"] = 106] = "SpecialtySororityFraternityHouse";
    PropertySubtype[PropertySubtype["HospitalitySingleRoomOccupancyHotel"] = 107] = "HospitalitySingleRoomOccupancyHotel";
    PropertySubtype[PropertySubtype["SpecialtyShelter"] = 108] = "SpecialtyShelter";
    PropertySubtype[PropertySubtype["SpecialtyRecyclingCenter"] = 109] = "SpecialtyRecyclingCenter";
    PropertySubtype[PropertySubtype["OfficeOfficeResidential"] = 110] = "OfficeOfficeResidential";
    PropertySubtype[PropertySubtype["OfficeOfficeLiveWorkUnit"] = 112] = "OfficeOfficeLiveWorkUnit";
    PropertySubtype[PropertySubtype["SpecialtyLumberyard"] = 113] = "SpecialtyLumberyard";
    PropertySubtype[PropertySubtype["OfficeIndustrialLiveWorkUnit"] = 114] = "OfficeIndustrialLiveWorkUnit";
    PropertySubtype[PropertySubtype["SpecialtyDriveInMovie"] = 115] = "SpecialtyDriveInMovie";
    PropertySubtype[PropertySubtype["GeneralRetailDepartmentStore"] = 116] = "GeneralRetailDepartmentStore";
    PropertySubtype[PropertySubtype["SpecialtyContractorStorageYard"] = 117] = "SpecialtyContractorStorageYard";
    PropertySubtype[PropertySubtype["OfficeBusinessPark"] = 118] = "OfficeBusinessPark";
    PropertySubtype[PropertySubtype["OfficeCallCenter"] = 119] = "OfficeCallCenter";
    PropertySubtype[PropertySubtype["OfficeD1"] = 120] = "OfficeD1";
    PropertySubtype[PropertySubtype["OfficeD2"] = 121] = "OfficeD2";
    PropertySubtype[PropertySubtype["OfficeServicedOffices"] = 122] = "OfficeServicedOffices";
    PropertySubtype[PropertySubtype["FlexBank"] = 123] = "FlexBank";
    PropertySubtype[PropertySubtype["FlexBusinessPark"] = 124] = "FlexBusinessPark";
    PropertySubtype[PropertySubtype["FlexCafe"] = 125] = "FlexCafe";
    PropertySubtype[PropertySubtype["FlexFoodCourt"] = 126] = "FlexFoodCourt";
    PropertySubtype[PropertySubtype["FlexMixedRetail"] = 127] = "FlexMixedRetail";
    PropertySubtype[PropertySubtype["FlexOutletCenter"] = 128] = "FlexOutletCenter";
    PropertySubtype[PropertySubtype["FlexPublicHouse"] = 129] = "FlexPublicHouse";
    PropertySubtype[PropertySubtype["FlexRetailOutOfTown"] = 130] = "FlexRetailOutOfTown";
    PropertySubtype[PropertySubtype["FlexSuperRegional"] = 131] = "FlexSuperRegional";
    PropertySubtype[PropertySubtype["FlexTradeCounterPark"] = 132] = "FlexTradeCounterPark";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentAllLeisure"] = 133] = "SportsAndEntertainmentAllLeisure";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentFitnessCenter"] = 134] = "SportsAndEntertainmentFitnessCenter";
    PropertySubtype[PropertySubtype["SportsAndEntertainmentNightclub"] = 135] = "SportsAndEntertainmentNightclub";
    PropertySubtype[PropertySubtype["SpecialtyConference"] = 136] = "SpecialtyConference";
    PropertySubtype[PropertySubtype["SpecialtyOfficeAndIndustrial"] = 137] = "SpecialtyOfficeAndIndustrial";
    PropertySubtype[PropertySubtype["IndustrialLightIndustrial"] = 139] = "IndustrialLightIndustrial";
    PropertySubtype[PropertySubtype["HealthcareIndependentLiving"] = 142] = "HealthcareIndependentLiving";
    PropertySubtype[PropertySubtype["MultifamilyDormitory"] = 143] = "MultifamilyDormitory";
    PropertySubtype[PropertySubtype["SpecialtyResidentialIncome"] = 144] = "SpecialtyResidentialIncome";
    PropertySubtype[PropertySubtype["OfficeBuilding"] = 145] = "OfficeBuilding";
    PropertySubtype[PropertySubtype["RetailBuilding"] = 146] = "RetailBuilding";
    PropertySubtype[PropertySubtype["StudentApartments"] = 190] = "StudentApartments";
    PropertySubtype[PropertySubtype["StudentManufacturedHousingMobileHomePark"] = 191] = "StudentManufacturedHousingMobileHomePark";
    PropertySubtype[PropertySubtype["StudentDormitory"] = 192] = "StudentDormitory";
})(PropertySubtype || (PropertySubtype = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ServiceType */
export var ServiceType;
(function (ServiceType) {
    ServiceType[ServiceType["Default"] = 0] = "Default";
    ServiceType[ServiceType["PlusCleaning"] = 1] = "PlusCleaning";
    ServiceType[ServiceType["ElectricClean"] = 2] = "ElectricClean";
    ServiceType[ServiceType["PlusElectric"] = 4] = "PlusElectric";
    ServiceType[ServiceType["UtilitiesChar"] = 5] = "UtilitiesChar";
    ServiceType[ServiceType["PlusAllUtilities"] = 6] = "PlusAllUtilities";
    ServiceType[ServiceType["FullServiceGross"] = 7] = "FullServiceGross";
    ServiceType[ServiceType["IndustrialGross"] = 8] = "IndustrialGross";
    ServiceType[ServiceType["ModifiedGross"] = 9] = "ModifiedGross";
    ServiceType[ServiceType["Net"] = 10] = "Net";
    ServiceType[ServiceType["Negotiable"] = 11] = "Negotiable";
    ServiceType[ServiceType["DoubleNet"] = 12] = "DoubleNet";
    ServiceType[ServiceType["TripleNet"] = 13] = "TripleNet";
    ServiceType[ServiceType["ToBeDetermined"] = 14] = "ToBeDetermined";
    ServiceType[ServiceType["TenantElectric"] = 15] = "TenantElectric";
    ServiceType[ServiceType["FullyRepairingInsuring"] = 16] = "FullyRepairingInsuring";
    ServiceType[ServiceType["InternalRepairingOnly"] = 17] = "InternalRepairingOnly";
    ServiceType[ServiceType["InternalRepairingInsuring"] = 18] = "InternalRepairingInsuring";
    ServiceType[ServiceType["FullServiceGrossNoPass"] = 19] = "FullServiceGrossNoPass";
})(ServiceType || (ServiceType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.SprinklerType */
export var SprinklerType;
(function (SprinklerType) {
    SprinklerType[SprinklerType["None"] = 0] = "None";
    SprinklerType[SprinklerType["Wet"] = 1] = "Wet";
    SprinklerType[SprinklerType["Dry"] = 2] = "Dry";
    SprinklerType[SprinklerType["EarlySuppressionFastResponse"] = 3] = "EarlySuppressionFastResponse";
})(SprinklerType || (SprinklerType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.BreeamType */
export var BreeamType;
(function (BreeamType) {
    BreeamType[BreeamType["None"] = 0] = "None";
    BreeamType[BreeamType["Pass"] = 1] = "Pass";
    BreeamType[BreeamType["Good"] = 2] = "Good";
    BreeamType[BreeamType["VeryGood"] = 3] = "VeryGood";
    BreeamType[BreeamType["Excellent"] = 4] = "Excellent";
    BreeamType[BreeamType["Outstanding"] = 5] = "Outstanding";
})(BreeamType || (BreeamType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ConstructionStatus */
export var ConstructionStatus;
(function (ConstructionStatus) {
    ConstructionStatus[ConstructionStatus["None"] = 0] = "None";
    ConstructionStatus[ConstructionStatus["Existing"] = 1] = "Existing";
    ConstructionStatus[ConstructionStatus["Demolished"] = 2] = "Demolished";
    ConstructionStatus[ConstructionStatus["Proposed"] = 3] = "Proposed";
    ConstructionStatus[ConstructionStatus["UnderConstruction"] = 4] = "UnderConstruction";
    ConstructionStatus[ConstructionStatus["UnderRenovation"] = 5] = "UnderRenovation";
    ConstructionStatus[ConstructionStatus["Converted"] = 6] = "Converted";
    ConstructionStatus[ConstructionStatus["Unconfirmed"] = 7] = "Unconfirmed";
    ConstructionStatus[ConstructionStatus["Deferred"] = 8] = "Deferred";
    ConstructionStatus[ConstructionStatus["Abandoned"] = 9] = "Abandoned";
    ConstructionStatus[ConstructionStatus["FinalPlanning"] = 10] = "FinalPlanning";
})(ConstructionStatus || (ConstructionStatus = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.RetailLocation */
export var RetailLocation;
(function (RetailLocation) {
    RetailLocation[RetailLocation["None"] = 0] = "None";
    RetailLocation[RetailLocation["HighStreet"] = 1] = "HighStreet";
    RetailLocation[RetailLocation["OutOfTown"] = 2] = "OutOfTown";
})(RetailLocation || (RetailLocation = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.LeedType */
export var LeedType;
(function (LeedType) {
    LeedType[LeedType["None"] = 0] = "None";
    LeedType[LeedType["LeedCertified"] = 1] = "LeedCertified";
    LeedType[LeedType["Gold"] = 2] = "Gold";
    LeedType[LeedType["Platinum"] = 3] = "Platinum";
    LeedType[LeedType["Silver"] = 4] = "Silver";
    LeedType[LeedType["PreCertified"] = 5] = "PreCertified";
    LeedType[LeedType["Registered"] = 6] = "Registered";
})(LeedType || (LeedType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ConstructionMaterial */
export var ConstructionMaterial;
(function (ConstructionMaterial) {
    ConstructionMaterial[ConstructionMaterial["None"] = 0] = "None";
    ConstructionMaterial[ConstructionMaterial["Masonry"] = 1] = "Masonry";
    ConstructionMaterial[ConstructionMaterial["Metal"] = 2] = "Metal";
    ConstructionMaterial[ConstructionMaterial["ReinforcedConcrete"] = 3] = "ReinforcedConcrete";
    ConstructionMaterial[ConstructionMaterial["Steel"] = 4] = "Steel";
    ConstructionMaterial[ConstructionMaterial["WoodFrame"] = 5] = "WoodFrame";
})(ConstructionMaterial || (ConstructionMaterial = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.LocationType */
export var LocationType;
(function (LocationType) {
    LocationType[LocationType["None"] = 0] = "None";
    LocationType[LocationType["CentralBusinessDistrict"] = 1] = "CentralBusinessDistrict";
    LocationType[LocationType["Suburban"] = 2] = "Suburban";
    LocationType[LocationType["Downtown"] = 3] = "Downtown";
    LocationType[LocationType["Midtown"] = 4] = "Midtown";
    LocationType[LocationType["Outlying"] = 5] = "Outlying";
    LocationType[LocationType["Urban"] = 6] = "Urban";
})(LocationType || (LocationType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.OwnershipType */
export var OwnershipType;
(function (OwnershipType) {
    OwnershipType[OwnershipType["None"] = 0] = "None";
    OwnershipType[OwnershipType["FeeSimple"] = 1] = "FeeSimple";
    OwnershipType[OwnershipType["Condo"] = 2] = "Condo";
    OwnershipType[OwnershipType["LeaseHold"] = 3] = "LeaseHold";
    OwnershipType[OwnershipType["LeaseFee"] = 4] = "LeaseFee";
    OwnershipType[OwnershipType["PUD"] = 5] = "PUD";
})(OwnershipType || (OwnershipType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.AffordableRentSubtype */
export var AffordableRentSubtype;
(function (AffordableRentSubtype) {
    AffordableRentSubtype[AffordableRentSubtype["None"] = 0] = "None";
    AffordableRentSubtype[AffordableRentSubtype["RentRestricted"] = 1] = "RentRestricted";
    AffordableRentSubtype[AffordableRentSubtype["RentSubsidized"] = 2] = "RentSubsidized";
    AffordableRentSubtype[AffordableRentSubtype["RentControlled"] = 3] = "RentControlled";
    AffordableRentSubtype[AffordableRentSubtype["RentStabilized"] = 4] = "RentStabilized";
    AffordableRentSubtype[AffordableRentSubtype["AffordableUnits"] = 5] = "AffordableUnits";
})(AffordableRentSubtype || (AffordableRentSubtype = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ApartmentLifestyleType */
export var ApartmentLifestyleType;
(function (ApartmentLifestyleType) {
    ApartmentLifestyleType[ApartmentLifestyleType["None"] = 0] = "None";
    ApartmentLifestyleType[ApartmentLifestyleType["All"] = 1] = "All";
    ApartmentLifestyleType[ApartmentLifestyleType["Senior"] = 2] = "Senior";
    ApartmentLifestyleType[ApartmentLifestyleType["Student"] = 3] = "Student";
    ApartmentLifestyleType[ApartmentLifestyleType["Military"] = 4] = "Military";
    ApartmentLifestyleType[ApartmentLifestyleType["Corporate"] = 5] = "Corporate";
    ApartmentLifestyleType[ApartmentLifestyleType["Vacation"] = 6] = "Vacation";
})(ApartmentLifestyleType || (ApartmentLifestyleType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ApartmentMeteringType */
export var ApartmentMeteringType;
(function (ApartmentMeteringType) {
    ApartmentMeteringType[ApartmentMeteringType["None"] = 0] = "None";
    ApartmentMeteringType[ApartmentMeteringType["MasterMetered"] = 1] = "MasterMetered";
    ApartmentMeteringType[ApartmentMeteringType["IndividuallyMetered"] = 2] = "IndividuallyMetered";
})(ApartmentMeteringType || (ApartmentMeteringType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ApartmentOwnershipType */
export var ApartmentOwnershipType;
(function (ApartmentOwnershipType) {
    ApartmentOwnershipType[ApartmentOwnershipType["None"] = 0] = "None";
    ApartmentOwnershipType[ApartmentOwnershipType["Condo"] = 1] = "Condo";
    ApartmentOwnershipType[ApartmentOwnershipType["Cooperative"] = 2] = "Cooperative";
})(ApartmentOwnershipType || (ApartmentOwnershipType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ApartmentRentType */
export var ApartmentRentType;
(function (ApartmentRentType) {
    ApartmentRentType[ApartmentRentType["None"] = 0] = "None";
    ApartmentRentType[ApartmentRentType["Market"] = 1] = "Market";
    ApartmentRentType[ApartmentRentType["Affordable"] = 2] = "Affordable";
    ApartmentRentType[ApartmentRentType["MarketAffordable"] = 3] = "MarketAffordable";
})(ApartmentRentType || (ApartmentRentType = {}));
/** CoStar.Api.ExternalApi.ViewModels.Suite.ApartmentRoofType */
export var ApartmentRoofType;
(function (ApartmentRoofType) {
    ApartmentRoofType[ApartmentRoofType["None"] = 0] = "None";
    ApartmentRoofType[ApartmentRoofType["Flat"] = 1] = "Flat";
    ApartmentRoofType[ApartmentRoofType["Mansard"] = 2] = "Mansard";
    ApartmentRoofType[ApartmentRoofType["PitchedComposition"] = 3] = "PitchedComposition";
    ApartmentRoofType[ApartmentRoofType["PitchedShingle"] = 4] = "PitchedShingle";
    ApartmentRoofType[ApartmentRoofType["PitchedTile"] = 5] = "PitchedTile";
    ApartmentRoofType[ApartmentRoofType["PitchedWood"] = 6] = "PitchedWood";
    ApartmentRoofType[ApartmentRoofType["Slanted"] = 7] = "Slanted";
})(ApartmentRoofType || (ApartmentRoofType = {}));
import { ApartmentStyleType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.ExternalApi.ViewModels.Suite.ApartmentStyleType */
export { ApartmentStyleType };
/** CoStar.Api.ExternalApi.ViewModels.Suite.SidingType */
export var SidingType;
(function (SidingType) {
    SidingType[SidingType["None"] = 0] = "None";
    SidingType[SidingType["Brick"] = 1] = "Brick";
    SidingType[SidingType["CinderBlock"] = 2] = "CinderBlock";
    SidingType[SidingType["FiberCement"] = 3] = "FiberCement";
    SidingType[SidingType["Metal"] = 4] = "Metal";
    SidingType[SidingType["Stone"] = 5] = "Stone";
    SidingType[SidingType["StuccoSynthetic"] = 5] = "StuccoSynthetic";
    SidingType[SidingType["StuccoTraditional"] = 5] = "StuccoTraditional";
    SidingType[SidingType["T111"] = 5] = "T111";
    SidingType[SidingType["Vinyl"] = 5] = "Vinyl";
    SidingType[SidingType["Wood"] = 5] = "Wood";
})(SidingType || (SidingType = {}));
